import { components } from 'react-select'
import { dateTimeValidation } from '~/utils/date'

const useDateTimeMask = () => {
  let oldValue, oldCursor

  // Regex to validate a datetime pattern with numbers only
  const regex = /^\d{0,12}$/g

  const mask = (value) => {
    if (!value) return ''

    // Extract only digits
    const digits = value.replace(/\D/g, '')

    // Check if the date parts are valid
    if (!dateTimeValidation.validatePartialDate(digits)) {
      return oldValue || ''
    }

    // Check if the time parts are valid (if present)
    if (!dateTimeValidation.validatePartialTime(digits)) {
      return oldValue || ''
    }

    // Format as YYYY-MM-DD HH:MM
    const output = []
    for (let i = 0; i < digits.length && i < 12; i++) {
      if (i === 4 || i === 6) {
        output.push('-') // add date separator
      } else if (i === 8) {
        output.push(' ') // add space between date and time
      } else if (i === 10) {
        output.push(':') // add time separator
      }
      output.push(digits[i])
    }

    return output.join('')
  }

  const unmask = (value) => value.replace(/\D/g, '')

  const checkSeparator = (position) => {
    if (position <= 4) return 0
    if (position <= 7) return 1
    if (position <= 10) return 2
    if (position <= 13) return 3
    return 4
  }

  const onKeyDown = ({ target }) => {
    oldValue = target.value
    oldCursor = target.selectionEnd
  }

  const onInput = (e) => {
    const el = e.target
    const unmaskedValue = unmask(el.value)
    let newValue, newCursorPosition

    if (unmaskedValue.match(regex)) {
      newValue = mask(unmaskedValue)

      // Calculate the new cursor position
      const oldSeparatorCount = checkSeparator(oldCursor)
      const newSeparatorCount = checkSeparator(oldCursor + (unmaskedValue.length - unmask(oldValue).length))

      newCursorPosition = oldCursor + (newValue.length - oldValue.length) + (newSeparatorCount - oldSeparatorCount)

      el.value = newValue
    } else {
      el.value = oldValue
      newCursorPosition = oldCursor
    }

    el.setSelectionRange(newCursorPosition, newCursorPosition)
  }

  return { onKeyDown, onInput }
}

export default function DateTimeInput(props) {
  const { onInput, onKeyDown } = useDateTimeMask()

  return <components.Input {...props} onInput={onInput} onKeyDown={onKeyDown} placeholder='yyyy-mm-dd hh:mm' />
}
